<template>
  <vbt-dialog
    v-model="dialog"
    :title="title"
    :submit-btn-name="submitBtnName"
    @submit="submitForm"
    @close="resetFormValidation"
  >
    <v-text-field
      v-model.trim="form.name"
      :rules="validator.getRulesByField('name')"
      label="Name"
    />
    <v-text-field
      v-model.trim="form.abbreviation"
      :rules="validator.getRulesByField('abbreviation')"
      label="Abbreviation"
    />
    <v-select
      v-model="form.flags"
      :items="productFlags"
      label="Flags"
      multiple
    />
  </vbt-dialog>
</template>

<script>
import { mapState } from 'vuex';

import { useDialog, useEditor, useFormWithRef } from '@mixins/factories';

import { Validator, wrapToLoadingFn } from '@helpers';

import { namespace as EnumsNamespace } from '@store/modules/enums.types';
import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import ProductsApiService from '../_services/products.api.service';

import { generateProductModel } from '../_models/product.model';

const validator = Validator.createValidator({
  name: ['required'],
  abbreviation: ['required'],
});

export default {
  name: 'KernelProductEditor',
  mixins: [
    useDialog(),
    useFormWithRef(),
    Validator.useValidator(validator),
    useEditor({ formGenerator: generateProductModel }),
  ],
  computed: {
    ...mapState(LocationsNamespace, ['suffix']),
    ...mapState(EnumsNamespace, {
      productFlags: ({ enums: { productFlags: enums } }) => (enums || [])
        .map(({ value }) => value),
    }),
    title() {
      return this.creator ? 'Create product' : `Edit ${this.item.name}`;
    },
    action() {
      return this.creator ? ProductsApiService.createProduct : ProductsApiService.updateProduct;
    },
    submitPromptText() {
      return this.creator ? 'Create product?' : `Update product ${this.item.name}`;
    },
  },
  methods: {
    wrapToLoadingFn,
    submitForm() {
      if (!this.validateForm()) {
        return;
      }
      this.$VBlackerTheme.alert.warning({
        text: this.submitPromptText,
      }, () => this.wrapToLoadingFn({
        req: this.action.bind({}, {
          suffix: this.suffix,
          name: this.item.name,
          data: this.form,
        }),
        loadingSpinnerType: 'fullscreen',
        onSuccess: () => {
          this.$VBlackerTheme.notification.success(`Successfully ${
            this.creator ? 'created' : 'updated'
          }`);
          this.$emit('success');
          this.dialog = false;
        },
      }));
    },
  },
};
</script>
